import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Today from "./Today"; // Component for the "Today" tab
import History from "./History"; // Component for the "History" tab
import { getOrganizationTab } from "./Header";

const EmployeeHomePage = () => {
  const [user_id, setuser_id] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = getOrganizationTab("user", location.search);

  useEffect(() => {
    // Check if user_id exists in localStorage when the component mounts
    const storeduser_id = localStorage.getItem("userId");
    if (storeduser_id) {
      setuser_id(JSON.parse(storeduser_id)); // Set user_id from localStorage
    } else {
      navigate("/partner/login"); // Redirect to login if no user_id is found
    }
  }, [navigate]);

  if (!user_id) {
    return null; // Do nothing if user_id is missing
  }

  return activeTab === "History" ? <History user_id={user_id} /> : <Today user_id={user_id} />;
};

export default EmployeeHomePage;
